import { GameService } from "./../core/services/game.service";
import { Component, OnInit, AfterViewInit } from "@angular/core";
import { Location } from "@angular/common";
import { LoginService } from "../core/services/login.service";
import { interval } from "rxjs";
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { EventsService } from '../core/services/events.service';
declare const gapi: any;
declare var album: any;
declare var FB;

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"]
})
export class ProfileComponent implements OnInit {
  public auth2: any;
  msisdn = atob(localStorage.getItem("msisdn"));
  userName: string = "Your Name";
  userPicture = "../../assets/images/login_giga.png";
  haveSubDailyGame = false;
  haveSubDailyMultiplier = false;
  balance = 0;
  balanceExpireDate=0;
  googleConnected:boolean=false;
  facebokConnected:boolean=false;
  unSub = false;
  unSubController = false;

  constructor(
    private location: Location,
    private loginservice: LoginService,
    private gameservice: GameService,
    private router: Router,
    private events: EventsService
  ) {}

  ngOnInit() {
    this.events.eventStart({ eventType: 'MY_PROFILE_PAGE_ACCESS', triggerType: 'access' });
    this.facebookInit();
    this.getPlayerData();
    interval(10000).subscribe(timerResponse => {
      this.getPlayerData();
    });
  }

  ngAfterViewInit() {
    this.events.eventStart({ eventType: 'MY_PROFILE_PAGE_LOADED', triggerType: 'access' });
    this.googleInit();
  }

  getPlayerData() {
    this.gameservice.getPlayerData().subscribe(data => {
      console.log(data);
      if (data["responseCode"] == 200) {
        this.haveSubDailyGame = data["responseData"].haveSubDailyGame;
        this.haveSubDailyMultiplier =
          data["responseData"].haveSubDailyMultiplier;
        this.balance = data["responseData"].wallet.counters[3].label;
        this.balanceExpireDate = data["responseData"].wallet.counters[3].expireDate;
        this.unSubController = data['responseData'].isSubscribed;
      } else {
        localStorage.clear();
        this.router.navigate(['/login']);
      }
    });
  }

  facebookInit() {
    (window as any).fbAsyncInit = function() {
      FB.init({
        appId: "731718777229382",
        cookie: true,
        xfbml: true,
        version: "v3.1"
      });
      FB.AppEvents.logPageView();
    };

    (function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }
  connectFacebook() {
    FB.login(response => {
      if (response.authResponse) {
        FB.api(
          "/" + response.authResponse.userID,
          { fields: "name,picture" },
          response => {
            console.log(response);
            if (response && !response.error) {
              this.loginservice
                .connectSocialNetwork("FACEBOOK", response.id, response.name)
                .subscribe(data => {});
            }
          }
        );
      } else {
        console.log("User login failed");
      }
    });
  }

  goBack() {
    this.location.back();
  }

  googleInit() {
    gapi.load("auth2", () => {
      this.auth2 = gapi.auth2.init({
        client_id:
          "9876638035-16erp5f49ucaqdj9vfclnu9s2o0q6tke.apps.googleusercontent.com",
        cookiepolicy: "single_host_origin",
        scope: "profile email"
      });
      console.log("aqui");

      this.attachSignin(document.getElementById("googleBtn"));
    });
  }
  attachSignin(element) {
    this.auth2.attachClickHandler(
      element,
      {},
      googleUser => {
        let profile = googleUser.getBasicProfile();
        console.log("Token || " + googleUser.getAuthResponse().id_token);
        console.log("ID: " + profile.getId());
        console.log("Name: " + profile.getName());
        console.log("Image URL: " + profile.getImageUrl());
        console.log("Email: " + profile.getEmail());
        //YOUR CODE HERE
        this.loginservice
          .connectSocialNetwork(
            "GOOGLE",
            profile.getId(),
            profile.getName(),
            profile.getImageUrl()
          )
          .subscribe(data => {
            console.log(data);
          });
      },
      error => {
        alert(JSON.stringify(error, undefined, 2));
      }
    );
  }

  logout() {
    this.events.eventStart({ eventType: 'LOGOUT_SUCESS', triggerType: 'access' });
    localStorage.clear();
    window.location.reload()
  }
  unsub() {
    this.events.eventStart({ eventType: 'UNSUBSCRIPTION', triggerType: 'submit' });
    this.loginservice.unsub().subscribe(data => {
      if(data['responseCode']==200){
        //localStorage.setItem('token', data['responseData'])
        this.events.eventStart({ eventType: 'UNSUBSCRIPTION_SUCCESS', triggerType: 'success', responseData: JSON.stringify(data) });
        this.unSub=true;
      } else {
        this.events.eventStart({ eventType: 'UNSUBSCRIPTION_ERROR', triggerType: 'error', responseData: JSON.stringify(data) });
      }
      
     // window.location.reload()
    });
   
  }
}
